import type { ReactNode } from "react";

import { AppText } from "./AppText";
import { Stack } from "./Stack";

/** Card/section intro: title + optional supporting line. */
export function SectionHeader({
  title,
  description,
}: {
  title: string;
  description?: ReactNode;
}) {
  return (
    <Stack gap="xs">
      <AppText size="base" weight="semibold">
        {title}
      </AppText>
      {description ? (
        typeof description === "string" ? (
          <AppText size="xs" tone="muted">
            {description}
          </AppText>
        ) : (
          description
        )
      ) : null}
    </Stack>
  );
}
